

<div id="consultant-email-invitation-reminder-modal-id" class="modal">
  <!-- Modal content -->
  <div class="modal-content">
    <div class="modal-header">
      <span class="close" (click)="closeConsultantInvitationModal()">&times;</span>
      <br>
      <div *ngIf="showModalErrorMessages" class="container st-form text-danger">
        <app-st-span [inputVal]="'Please validate the following: '"></app-st-span>
        <div *ngFor="let errorMsg of modalErrorMessages" class="alert alert-danger" role="alert">
          <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
        </div>
        <br>
      </div>
      <div *ngIf="showModalSuccessMessages" class="container st-form text-success">
        <div *ngFor="let successMsg of modalSuccessMessages" class="alert alert-success" role="alert">
          <b>{{successMsg.field}}:</b> {{successMsg.detail}}
        </div>
        <br>
      </div>
      <br>
    </div>
    <div class="modal-body">
      <br>
      <app-st-header-title [inputVal]="'Manage a Consultant:'"></app-st-header-title>

      <p class="webtext-black" style="font-size: 20px;"><b>Collaborate with Your Fundraising Team</b></p>
      <p class="webtext-black">Scalanthropy makes it easy to collaborate with trusted fundraising consultants, grant writers, campaign advisors, and development professionals who support your organization.</p>
      <p class="webtext-black">As an active subscriber, you can invite one consultant to access your Scalanthropy account at no additional cost while they are actively engaged with your organization.</p>
      <br>
      <p class="webtext-black" style="font-size: 20px;"><b>Flexible Access Levels</b></p>
      <p class="webtext-black">Choose the level of access that best fits your working relationship:</p>
      <br>
      <p class="webtext-black" style="font-size: 20px;"><b>Read-Only Access</b></p>
      <p class="webtext-black">Provide a consultant with visibility into your fundraising strategy without allowing changes to your account. Read-only users can view information such as:</p>
      <ul class="webtext-black">
        <li>Saved donor and funder searches</li>
        <li>Funding goals and priorities</li>
        <li>Prospect lists</li>
        <li>Research and insights</li>
        <li>Account activity and reporting</li>
      </ul>
      <br>

      <p class="webtext-black" style="font-size: 20px;"><b>Collaborative Access</b></p>
      <p class="webtext-black">Empower your consultant to work alongside your team by allowing them to actively manage and support your fundraising efforts. Collaborative users can:</p>
      <ul class="webtext-black">
        <li>Conduct donor and funder research</li>
        <li>Create and manage saved searches</li>
        <li>Build prospect lists</li>
        <li>Update funding goals and opportunities</li>
        <li>Assist with strategy development and account management</li>
      </ul>
      <br>
      <p class="webtext-black" style="font-size: 20px;"><b>Simple, Secure, and Controlled</b></p>

      <p class="webtext-black">You remain in control of your account at all times. Your consultant can only access your organization through an invitation from your team, and access can be modified or removed whenever needed.</p>

      <p class="webtext-black">Invite your trusted fundraising partners and get more value from your Scalanthropy subscription while keeping everyone aligned around your fundraising goals.
      </p>
      <!--
      <app-st-span [inputVal]="'Consultant Email'"></app-st-span>
      <app-st-input-text [idVal]="'modal-consultant-email-text-id'" [label]="''" [placeHolderVal]="'Consultant Email'" [width]="'95%'"></app-st-input-text>
      <br>
      <app-st-span [inputVal]="'Client Email'"></app-st-span>
      <app-st-input-text [idVal]="'modal-client-email-text-id'" [label]="''" [placeHolderVal]="'Client Email'" [width]="'95%'"></app-st-input-text>
      -->
    </div>
    <br>
    <div class="modal-footer">
      <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
        <app-st-button [idVal]="'invite-consultant-email-modal-button1-id'" [label]="'Invite Consultant'" [primary]="false"
                       (click)="this.inviteConsultantToCollaborate()"></app-st-button>
        <app-st-button-white [idVal]="'close-modal-button1-id'" [label]="'Close'" [primary]="false"
                             (click)="closeConsultantInvitationModal()"></app-st-button-white>
      </div>
    </div>
  </div>
</div>

<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br><br><br><br>

<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-8">
      <app-st-header-title [inputVal]="'Your Subscription'"></app-st-header-title>
    </div>
  </div>
  <br>
  <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
    <app-st-span [inputVal]="'An error has occurred: '"></app-st-span>
    <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div *ngIf="this.showPageSuccessMessages" class="container st-form text-success" #goUp>
    <div *ngFor="let successMsg of pageSuccessMessages" class="alert alert-success" role="alert">
      <b>{{successMsg.field}}:</b> {{successMsg.detail}}
    </div>
    <br>
  </div>
  <div class="container st-form">
    <div class="row">
      <div class="col-sm-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Subscription Status: <strong *ngIf="this.subscriptionActive">Active</strong><strong *ngIf="!this.subscriptionActive">Inactive</strong></h5>
            <p class="card-text" *ngIf="this.subscriptionActive && this.isConsultant != 'Y' && this.hasClients != 'Y'">Expires on {{subscriptionExpirationDate}}.
              <span *ngIf="this.subscriptionActive && this.cancelAtPeriodEnd"> Will cancel once period ends.</span>
            </p>
            <p class="card-text" *ngIf="this.subscriptionActive && this.isConsultant == 'Y' && this.hasClients == 'Y'">Since your clients are active subscribers, this subscription is free of charge for now!
              <span *ngIf="this.subscriptionActive && this.cancelAtPeriodEnd"> Will cancel once period ends.</span>
            </p>
            <p class="card-text" *ngIf="this.mostRecentSubscription.futureNotStartedScheduledSubscription"> Your newly changed subscription will start in the future on {{subscriptionExpirationDate}}.</p>
            <p class="card-text" *ngIf="!this.subscriptionActive">Expired on {{subscriptionExpirationDate}}. Please renew.</p>
            <p class="card-text" *ngIf="!this.mostRecentSubscription.rootEmailFlag"> Only your root email user can reactivate, change, or cancel your subscription.</p>
            <br>
            <br>
            <app-st-button *ngIf="this.subscriptionActive && !this.cancelAtPeriodEnd && this.mostRecentSubscription.rootEmailFlag" [idVal]="'cancel-renewal-button-id'" [label]="'Cancel Renewal'" [primary]="true"
                           (click)="this.navToCancelRenewalPage()"></app-st-button>
            &nbsp;
            <!--
            <app-st-button *ngIf="this.subscriptionActive && this.mostRecentSubscription.rootEmailFlag" [idVal]="'change-subscription-button-id'" [label]="'Change Subscription'" [primary]="true"
                           (click)="this.navToChangeSubscriptionPage()"></app-st-button>-->
            &nbsp;
            <app-st-button *ngIf="!this.subscriptionActive && this.mostRecentSubscription.rootEmailFlag" [idVal]="'activate-subscription-button-id'" [label]="'Activate Subscription'" [primary]="true"
                           (click)="this.navToActivateSubscriptionPage()"></app-st-button>
            <app-st-button *ngIf="this.mostRecentSubscription.rootEmailFlag" [idVal]="'update-payment-method-button-id'" [label]="'Update Cards'" [primary]="true"
                           (click)="this.navToUpdatePaymentMethod()"></app-st-button>
          </div>
        </div>
      </div>
      <div *ngIf="this.savedIsConsultantFlag == 'Y'" class="col-sm-6">
        <div *ngIf="this.showReferralCodeErrorMessages" class="container st-form text-danger" #goUp>
          <app-st-span [inputVal]="'An error has occurred: '"></app-st-span>
          <div *ngFor="let errorMsg of this.referralCodeErrorMessages" class="alert alert-danger" role="alert">
            <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
          </div>
          <br>
        </div>
        <div *ngIf="this.showReferralCodeSuccessMessages" class="container st-form text-success" #goUp>
          <div *ngFor="let successMsg of this.referralCodeSuccessMessages" class="alert alert-success" role="alert">
            <b>{{successMsg.field}}:</b> {{successMsg.detail}}
          </div>
          <br>
        </div>
        <div class="card">
          <div class="row pt-2">
            <div class="col">
              <div class="card-body">
                <h5 class="card-title"><strong>Verify your Consultant Referral Code here!</strong></h5>
                <app-st-input-text [idVal]="'referral-code-text-id'" [label]="''" [placeHolderVal]="'Referral Code'" [width]="'95%'"></app-st-input-text>
                <br>
                <app-st-button [idVal]="'verify-referral-code-button-id'" [label]="'Verify'" [primary]="true"
                               (click)="this.verifyConsultantReferralCodeWithActiveAccount()"></app-st-button>
                <br>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="this.savedIsConsultantFlag != 'Y'" class="col-sm-6">
        <div class="card">
          <div class="row pt-2" *ngIf="savedConsultantId == -1 && !this.inviteButtonClicked" >
            <div class="col">
              <div class="card-body">
                <h5 class="card-title"><strong>Extend Your Fundraising Team:</strong></h5>
                <i class="webtext-black" style="font-size: 12px;">Provide trusted a consultant with secure access to your Scalanthropy account. Choose read-only access for visibility or collaborative access for hands-on support.</i>
                <br>
                <app-st-input-text [idVal]="'consultant-email-text-id'"
                                   [label]="'*Consultant Email'" [inputVal]="savedConsultantEmail"
                                   [disabled]="false"
                                   [maxLength]="100"
                ></app-st-input-text>
                <!--
                <app-st-autocomplete-consultant-key-lookup [idVal]="'consultant-email-text-id'"
                                                           [label]="'*Search Consultant Email'" [items]="this.consultantAutocomplete"
                                                           [disabled]="false"
                                                           [maxLength]="100"
                                                           [width]="'95%'"
                ></app-st-autocomplete-consultant-key-lookup>-->
                <div>
                  <input class="form-check-input radio-button-properties" type="radio" value="'READ_ONLY_ACCESS'" id="flexRadioConsultantReadOnly"
                         (click)="trackAccessLogicalExpression('READ_ONLY_ACCESS')" [checked]="consultantReadOnlyButton">
                  <label class="form-check-label checkbox-text webtext-black" for="flexRadioConsultantReadOnly">
                    &nbsp;Read-Only Access
                  </label>
                  &nbsp;&nbsp;
                  <input class="form-check-input radio-button-properties" type="radio" value="'COLLABORATIVE_ACCESS'" id="flexRadioConsultantManager"
                         (click)="trackAccessLogicalExpression('COLLABORATIVE_ACCESS')" [checked]="consultantManagerButton">
                  <label class="form-check-label checkbox-text webtext-black" for="flexRadioConsultantManager">
                    &nbsp;Collaborative Access
                  </label>
                </div>
                <br>
                <app-st-button [idVal]="'invite-consultant-button-id'" [label]="'Invite a Consultant'" [primary]="true"
                               (click)="this.openConsultantInvitationModal()"></app-st-button>
                <br>
              </div>
            </div>
          </div>
          <div class="row pt-2" *ngIf="savedConsultantId && savedConsultantId > 0 && savedConsultantEmail">
            <div class="col">
              <div class="card-body">
                <h5 class="card-title"><strong>Extend Your Fundraising Team:</strong></h5>
                <app-st-input-text [idVal]="'consultant-email-text-id'"
                                   [label]="'*Consultant Email'" [inputVal]="savedConsultantEmail"
                                   [disabled]="true"
                                   [maxLength]="100"
                ></app-st-input-text>
                <div>
                  <input class="form-check-input radio-button-properties" type="radio" value="'READ_ONLY_ACCESS'" id="flexRadioConsultantReadOnly2"
                         (click)="trackAccessLogicalExpression('READ_ONLY_ACCESS')" [checked]="consultantReadOnlyButton">
                  <label class="form-check-label checkbox-text webtext-black" for="flexRadioConsultantReadOnly2">
                    &nbsp;Read-Only Access
                  </label>
                  &nbsp;&nbsp;
                  <input class="form-check-input radio-button-properties" type="radio" value="'COLLABORATIVE_ACCESS'" id="flexRadioConsultantManager2"
                         (click)="trackAccessLogicalExpression('COLLABORATIVE_ACCESS')" [checked]="consultantManagerButton">
                  <label class="form-check-label checkbox-text webtext-black" for="flexRadioConsultantManager2">
                    &nbsp;Collaborative Access
                  </label>
                </div>
                <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
                  <app-st-button [idVal]="'update-consultant-button-id'" [label]="'Update'" [primary]="true"
                                 (click)="this.updateConsultantRole()"></app-st-button>
                  <app-st-button-delete-all [idVal]="'remove-consultant-button-id'" [label]="'Remove'"
                                            (click)="this.removeConsultantFromUser()"></app-st-button-delete-all>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <br><br>
    <app-st-header-title [inputVal]="'Your Invoice History'"></app-st-header-title>
    <div>
      <table class="table table-striped webtext-black">
        <thead>
          <tr>
            <th scope="col">Date</th>
            <th scope="col">Paid Amount ($)</th>
            <th scope="col">Status</th>
            <th scope="col">View</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let invoiceDto of invoiceDtos; let i = index">
            <td>{{this.apiService.formatDate(invoiceDto['createdTs'])}}</td>
            <td>{{invoiceDto['amountPaid']}}</td>
            <td>{{invoiceDto['status']}}</td>
            <td><i class="bi bi-file-pdf st-pdf-button" (click)="viewInvoice(invoiceDto)"></i></td>
          </tr>
        </tbody>
      </table>
      <br>
      <app-st-button-back-to-top></app-st-button-back-to-top>
    </div>
  </div>
</div>
